import { ITextbook, ITextbookConversion } from '~/types/textbook'
import http from '~/utils/http'

/** 获取教材 */
export function getTextbookByCategoryId(categoryId: number) {
  return http.get(`/admin/textbook/${categoryId}`, {
    params: {},
  })
}
/** 获取教材 */
export function getTextbookByParentId(parentId: number) {
  return http.get(`/admin/textbook/sub/${parentId}`, {
    params: {},
  })
}

/** 新增教材 */
export function postTextbook(data: Partial<ITextbook>) {
  return http.post('/admin/textbook', data)
}

/** 删除教材 */
export function deleteTextbook(id: number) {
  return http.delete(`/admin/textbook/${id}`)
}

/** 编辑教材 */
export function patchTextbook(id: number, data: Partial<ITextbook>) {
  return http.patch(`/admin/textbook/${id}`, data)
}

/** 教材及其下所有章节的白板转换状态 */
export function getTextbookConversions(id: number) {
  return http.get<ITextbookConversion[]>(`/admin/textbook/${id}/conversion`, {
    params: { recursive: true },
  })
}

/** 提交白板转换；recursive 包含其下所有章节，force 对已转换的重新转换 */
export function postTextbookConversion(
  id: number,
  data: { force?: boolean; recursive?: boolean } = {},
) {
  return http.post<{ requested: number; skipped: number }>(
    `/admin/textbook/${id}/conversion`,
    data,
  )
}
